// AuthPrompt.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AuthPrompt = ({ onClose }) => {
  const navigate = useNavigate();

  return (
	<div className="auth-prompt-overlay" onClick={onClose}>
	  <div className="auth-prompt" onClick={e => e.stopPropagation()}>
		<h3>Sign in to continue</h3>
		<p>You need to be signed in to perform this action.</p>
		<div className="auth-prompt-buttons">
		  <button 
			className="auth-button" 
			onClick={() => navigate('/login')}
		  >
			Sign In
		  </button>
		  <button 
			className="auth-button secondary" 
			onClick={onClose}
		  >
			Cancel
		  </button>
		</div>
	  </div>
	</div>
  );
};

export default AuthPrompt;